<script lang="ts">
  import { onMount } from 'svelte';
  import Swiper from 'swiper';
  import { Navigation, Thumbs } from 'swiper/modules';
  import 'swiper/css';
  import 'swiper/css/navigation';
  import type { PhotoGallery } from '../types';

  export let images: PhotoGallery['images'];

  let element: HTMLDivElement;
  let thumbnail: HTMLDivElement;
  let uniqueId = Math.random().toString(36).substring(2, 15);

  onMount(async () => {
    const swiperThumbnail = new Swiper(thumbnail, {
      loop: true,
      spaceBetween: 5,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    });

    new Swiper(element, {
      modules: [Navigation, Thumbs],
      direction: 'horizontal',
      loop: true,
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 25,
        },
      },
      navigation: {
        nextEl: `#swiper-button-next-${uniqueId}`,
        prevEl: `#swiper-button-prev-${uniqueId}`,
      },
      thumbs: {
        swiper: swiperThumbnail,
      },
    });
  });
</script>

<head>
  <link
    href="https://fonts.googleapis.com/icon?family=Material+Icons&display=swap"
    rel="stylesheet"
  />
</head>

<!-- Slider main container -->
<div class="swiper" bind:this={element}>
  <div class="swiper-wrapper">
    {#each images as { value }, i (i)}
      <div class="swiper-slide">
        <img src={value} alt="gallery-img" />
      </div>
    {/each}
  </div>
  <!-- navigation buttons -->
  <div class="swiper-button-prev" id="swiper-button-prev-{uniqueId}" />
  <div class="swiper-button-next" id="swiper-button-next-{uniqueId}" />
</div>

<!-- Mobile thumbnail -->
<div class="swiper-thumbnail" bind:this={thumbnail}>
  <div class="swiper-wrapper">
    {#each images as { value }, i (i)}
      <div class="swiper-slide">
        <img src={value} alt="gallery-thumbnail" />
      </div>
    {/each}
  </div>
</div>
